import { mapValues } from 'lodash-es';
import { CLIENT_REFERENCE_FILTER_NOT_SET } from 'anchor-scout-common/types';
import { SearchFilterType } from '~/components/TableFilters/types';
import { REFERENCE_FILTER_EVERY_VALUE, REFERENCE_FILTER_MAX_VALUES, SELECT_ALL_REFERENCE_FILTER, isSelectAllReferenceFilter, referenceColumnId } from './ClientsPage.referenceFields.utils';
import { ALL_CLIENT_TYPES } from './ClientsPage.utils';
const coversEveryOption = (value, optionCount)=>!Array.isArray(value) || value.length === 0 || value.length === optionCount;
export const clientsFilterConfig = (param)=>{
    let { statusFilterOptions, typeFilterOptions } = param;
    return {
        status: {
            type: SearchFilterType.MultiSelectFilter,
            removable: false,
            options: [
                ...statusFilterOptions
            ],
            mobile: {
                isEmptyValue: (value)=>coversEveryOption(value, statusFilterOptions.length)
            }
        },
        type: {
            type: SearchFilterType.MultiSelectFilter,
            removable: false,
            options: [
                ...typeFilterOptions
            ],
            mobile: {
                isEmptyValue: (value)=>coversEveryOption(value, typeFilterOptions.length)
            }
        }
    };
};
export const clientsFilterSelection = (param)=>{
    let { filters, statusFilterOptions } = param;
    const selectedStatus = filters.status;
    const selectedType = filters.type;
    return {
        status: (selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.length) ? selectedStatus : statusFilterOptions.map((option)=>option.value),
        type: (selectedType === null || selectedType === void 0 ? void 0 : selectedType.length) ? selectedType : ALL_CLIENT_TYPES
    };
};
const referenceFilterHelperText = (param, optionCount, helperTexts)=>{
    let { values: inUse, truncated } = param;
    const maxValuesHelper = truncated ? helperTexts.maxValuesHelper : helperTexts.maxValuesOrAllHelper;
    const lines = [
        ...truncated ? [
            helperTexts.truncatedHelper(inUse.length)
        ] : [],
        ...optionCount > REFERENCE_FILTER_MAX_VALUES ? [
            maxValuesHelper(REFERENCE_FILTER_MAX_VALUES)
        ] : []
    ];
    return lines.length === 0 ? undefined : lines.join(' ');
};
const pickedValuesNotInUse = function pickedValuesNotInUse() {
    let picked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], inUse = arguments.length > 1 ? arguments[1] : void 0;
    return picked.filter((value)=>value !== CLIENT_REFERENCE_FILTER_NOT_SET && value !== REFERENCE_FILTER_EVERY_VALUE && !inUse.includes(value));
};
export const referenceFilterConfig = (param)=>{
    let { fields, values, filters, notSetLabel, helperTexts } = param;
    return Object.fromEntries(fields.map((param)=>{
        let { key } = param;
        const options = [
            {
                value: CLIENT_REFERENCE_FILTER_NOT_SET,
                label: notSetLabel
            },
            ...values[key].values.map((value)=>({
                    value,
                    label: value
                })),
            ...pickedValuesNotInUse(filters[key], values[key].values).map((value)=>({
                    value,
                    label: value
                }))
        ];
        return [
            referenceColumnId(key),
            {
                type: SearchFilterType.MultiSelectFilter,
                removable: true,
                withSearchbox: true,
                selectAllByDefault: false,
                hideSelectAll: values[key].truncated,
                maxSelected: REFERENCE_FILTER_MAX_VALUES,
                loading: values[key].loading,
                helperText: referenceFilterHelperText(values[key], options.length, helperTexts),
                options
            }
        ];
    }));
};
export const referenceFilterOptionValues = (config)=>config.options.map((option)=>typeof option === 'string' ? option : option.value);
export const withSelectAllMarked = (param)=>{
    let { selection, previous, values, filterConfig } = param;
    return mapValues(selection, (selected, key)=>{
        var _previous_key;
        const { loaded, truncated } = values[key];
        const wasSelectAll = isSelectAllReferenceFilter((_previous_key = previous[key]) !== null && _previous_key !== void 0 ? _previous_key : []);
        const coversEveryOption = referenceFilterOptionValues(filterConfig[referenceColumnId(key)]).every((value)=>selected.includes(value));
        return (wasSelectAll || loaded && !truncated) && coversEveryOption ? [
            ...SELECT_ALL_REFERENCE_FILTER
        ] : selected;
    });
};
export const referenceFilterGroups = (fields, groupLabel)=>fields.length === 0 ? undefined : [
        {
            label: '',
            filters: [
                'status',
                'type'
            ]
        },
        {
            label: groupLabel,
            filters: fields.map((param)=>{
                let { key } = param;
                return referenceColumnId(key);
            })
        }
    ];
